
import { Options, Vue } from 'vue-class-component'
import Farm from '@/farm/Farm'
import EmployeeCard from '@/components/EmployeeCard.vue'
import ValueMeter from '@/components/ui/ValueMeter.vue'
import util from '../util'
import FarmStatusCard from '@/components/FarmStatusCard.vue'
import StatusBar from '@/components/StatusBar.vue'
import TextButton from '@/components/ui/TextButton.vue'
import SaveSystem from '@/SaveSystem'

@Options({
  components: {
    TextButton
  },
  props: {
    saveSystem: Object
  },
  methods: {
    log(msg: any) {
      console.log(msg)
    },
    util() {
      return util
    },
    date(unixTime: number) {
      let date = new Date(unixTime)
      return date.toLocaleString('sv-SE', { hour12: false, year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit' })
    },
    window() {
      return window
    }
  },
  computed: {
    farm: function (): Farm {
      return this.saveSystem.farm
    }
  },
  async created() {
    this.isLoaded = true
  }
})
export default class SavesCard extends Vue {
  isLoaded = false
  saveSystem!: SaveSystem
  selectedSaveName = ''
}
